import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as AiIcons from 'react-icons/ai';
import * as RiIcons from 'react-icons/ri';
import SafeIcon from '../common/SafeIcon';

const CURRENT_YEAR = 2026;

const footerLinks = [
  { path: '/about',    nameZh: '關於我們', nameEn: 'About Us',         icon: FiIcons.FiInfo },
  { path: '/features', nameZh: '功能介紹', nameEn: 'Features',         icon: FiIcons.FiLayers },
  { path: '/help',     nameZh: '使用幫助', nameEn: 'Help',             icon: FiIcons.FiHelpCircle },
  { path: '/contact',  nameZh: '聯絡我們', nameEn: 'Contact Us',       icon: FiIcons.FiMail },
  { path: '/privacy',  nameZh: '隱私政策', nameEn: 'Privacy Policy',   icon: FiIcons.FiShield },
  { path: '/terms',    nameZh: '使用條款', nameEn: 'Terms of Service', icon: FiIcons.FiFileText }
];

const socialLinks = [
  {
    href: 'https://www.threads.com/@homy.hk',
    label: 'Threads',
    icon: RiIcons.RiThreadsLine
  },
  {
    href: 'https://www.instagram.com/homy.hk',
    label: 'Instagram',
    icon: AiIcons.AiOutlineInstagram
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61578745554661',
    label: 'Facebook',
    icon: AiIcons.AiOutlineFacebook
  }
];

const Footer = ({ language }) => {
  return (
    <motion.footer
      className="mt-12 pb-6 border-t border-love-100 dark:border-gray-800 pt-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      role="contentinfo"
    >
      {/* Footer Navigation Links */}
      <nav aria-label={language === 'zh' ? '頁腳導航' : 'Footer navigation'}>
        <ul className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6 list-none p-0 m-0">
          {footerLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="text-gray-600 hover:text-love-500 dark:text-gray-400 dark:hover:text-love-400 transition-colors duration-200 flex items-center"
              >
                <SafeIcon icon={link.icon} className="mr-1 text-xs" aria-hidden="true" />
                <span>{language === 'zh' ? link.nameZh : link.nameEn}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Social Media Links */}
      <div className="flex items-center justify-center gap-4 mb-5">
        {socialLinks.map((s) => (
          <motion.a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            className="flex items-center justify-center w-9 h-9 rounded-full bg-love-50 hover:bg-love-100 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-500 hover:text-love-500 dark:text-gray-400 dark:hover:text-love-400 transition-all duration-200 shadow-sm"
            whileHover={{ scale: 1.12 }}
            whileTap={{ scale: 0.93 }}
          >
            <SafeIcon icon={s.icon} className="text-lg" aria-hidden="true" />
          </motion.a>
        ))}
      </div>

      {/* Copyright */}
      <div className="copyright text-gray-500 dark:text-gray-400 flex items-center justify-center">
        <span className="logo-heart" aria-hidden="true">❤️</span>
        <a
          href="https://homy.hk"
          target="_blank"
          rel="noopener noreferrer"
          className="homy-logo hover:text-love-500 transition-colors duration-300"
          aria-label="Visit Homy Tech Limited website"
        >
          Homy Tech Limited
        </a>
        <span className="logo-heart" aria-hidden="true">❤️</span>
      </div>

      {/* SEO Footer Text */}
      <p className="mt-4 text-xs text-center text-gray-400 dark:text-gray-500 m-0">
        © {CURRENT_YEAR} {language === 'zh'
          ? '愛情時光計算器 - 記錄美好時刻'
          : 'Love Time Calculator - Recording Beautiful Moments'}
      </p>
    </motion.footer>
  );
};

export default Footer;